import { useEffect, useState } from 'react';
import { getPortalUserUpdateSubject } from '../../../store/PortalUser';
import { getUser, managesTeam } from '../../../store/User';
import { missingAdviseTeam } from '../../../utils/adviseRoles';

export const useMissingAdviseTeam = (): boolean => {
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    if (managesTeam(getUser())) return;
    const sub = getPortalUserUpdateSubject().subscribe((user) => {
      const roleNames = (user?.roles ?? []).flatMap((role) => (role?.name ? [role.name] : []));
      setMissing(missingAdviseTeam(roleNames, user?.team_id));
    });
    return () => sub.unsubscribe();
  }, []);

  return missing;
};
